export default async function useAnnotationSources(ids: number[]) {
  const route = useRoute('onderzoek-slug___nl')

  return useAsyncData(
    `sources-${String(route.params.slug)}-${ids.join('-')}`,
    async () => {
      return queryCollection('annotation')
        .where('path', 'LIKE', `%${route.params.slug}%`)
        .where('title', 'IN', ids.map(String))
        .all()
    },
    {
      default() {
        return []
      },
    },
  )
}
